import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

import { DefaultEditor } from './default-editor';

@Component({
  selector: 'checkbox-editor',
  styleUrls: ['./editor.component.scss'],
  template: `
    <input
      [ngClass]="inputClass"
      type="checkbox"
      class="form-control"
      [formControl]="formControl"
      [name]="cell.getId()"
      [disabled]="!cell.isEditable()"
      [checked]="cell.getValue() == (cell.getColumn().getConfig()?.true || true)"
      (click)="onClick.emit($event)"
      (change)="onChange($event)"
    />
  `,
  standalone: false
})
export class CheckboxEditorComponent extends DefaultEditor {
  constructor() {
    super();
  }

  get formControl(): FormControl {
    return this.cell.getValidator() as FormControl;
  }

  public onChange(event: any) {
    const trueVal =
      (this.cell.getColumn().getConfig() &&
        this.cell.getColumn().getConfig().true) ||
      true;
    const falseVal =
      (this.cell.getColumn().getConfig() &&
        this.cell.getColumn().getConfig().false) ||
      false;
    this.cell.newValue = event.target.checked ? trueVal : falseVal;
  }
}